import { styled, WhmStack } from "@securitize/reactjs-whm";

export const WhmResponsiveStack = styled(WhmStack)(({ theme }) => ({
  flexDirection: "column",
  [theme.breakpoints.up("xl")]: {
    flexDirection: "row",
  },
}));
